/** External Dependencies */
import styled from 'styled-components';
import Input from '@scaleflex/ui/core/input';
import Select from '@scaleflex/ui/core/select';

const StyledFontFamilySelect = styled(Select)`
  width: 88px;
  margin: 0 4px;
`;

const StyledFontSizeInput = styled(Input)`
  width: 70px;
  margin: 0 4px;
`;

export { StyledFontFamilySelect, StyledFontSizeInput };
